import React, { useEffect, useState } from 'react';
import { Button, Grid, InputBase, TextField } from '@material-ui/core';
import Autocomplete from '@material-ui/lab/Autocomplete';
import AddCircleOutlineIcon from '@material-ui/icons/AddCircleOutline';
import ClearIcon from '@material-ui/icons/Clear';
import { SearchOutlined as SearchIcon } from '@material-ui/icons';
import Breadcrums from '../../../components/BreadCrums/breadcrums';
import TopSpacer from '../../../components/Common/spacer/TopSpacer';
import SearchGrid from '../../../components/table/SearchGrid';
import Loader from '../../../components/Loader/Loader';
import { withSnackbar } from '../../../components/Message/Alert';
import { PostDataAPI } from '../../../Services/APIService';
import AddCarton from './addCarton/AddCarton';
import useStyles from '../styles';

function Cartons({ showMessage }) {
    const classes = useStyles();
    const [cartons, setCartons] = useState([]);
    const [searchFilter, setSearchFilter] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const [isDataGridUpdate, setIsDataGridUpdate] = useState(false);
    const [cartonDialog, setCartonDialog] = useState(false);
    const [editItem, setEditItem] = useState({});
    const [itemTypeOptions, setItemTypeOptions] = useState([]);
    const [selectedItemType, setSelectedItemType] = useState(null);

    const loadCartons = (itemTypeId = selectedItemType ? selectedItemType.value : null) => {
        setIsLoading(true);
        PostDataAPI('deviceinventory/getCartonList', { ItemTypeId: itemTypeId }).then(result => {
            if (result.success) {
                setCartons((result.data || []).map(item => ({
                    ...item,
                    cartonNo: item.cartonNo || '-',
                    palletNo: item.palletNo || '-',
                    itemTypeName: item.itemTypeName || '-',
                    deviceCount: item.deviceCount === null || item.deviceCount === undefined ? '-' : item.deviceCount,
                    createdByName: item.createdByName || '-',
                    updatedByName: item.updatedByName || '-',
                })));
                setIsDataGridUpdate(previous => !previous);
            } else {
                setCartons([]);
                showMessage('Error', result.message || 'Error loading cartons, please contact administrator', 'error', 3000);
            }
            setIsLoading(false);
        }).catch(() => {
            setIsLoading(false);
            showMessage('Error', 'Error loading cartons, please contact administrator', 'error', 3000);
        });
    };

    useEffect(() => {
        loadCartons();
        PostDataAPI('deviceinventory/getItemTypeList', {}).then(result => {
            if (result.success) {
                setItemTypeOptions((result.data || [])
                    .filter(item => item.isActive === true)
                    .map(item => ({ label: item.name, value: item.itemTypeId })));
            } else {
                showMessage('Error', result.message || 'Error loading item types, please contact administrator', 'error', 3000);
            }
        }).catch(() => {
            showMessage('Error', 'Error loading item types, please contact administrator', 'error', 3000);
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const closeCartonDialog = () => {
        setEditItem({});
        setCartonDialog(false);
    };

    const handleSuccessClose = message => {
        closeCartonDialog();
        showMessage('Success', message, 'success', 3000);
        loadCartons();
    };

    const editCarton = item => {
        setEditItem(item);
        setCartonDialog(true);
    };

    const updateSearch = value => {
        setSearchFilter(value);
        setIsDataGridUpdate(previous => !previous);
    };

    const handleItemTypeChange = (event, option) => {
        setSelectedItemType(option);
        loadCartons(option ? option.value : null);
    };

    return (
        <>
            {isLoading ? <Loader /> : ''}
            <TopSpacer />
            <div className={classes.header}>
                <Grid container alignItems="baseline">
                    <Grid item lg={12}>
                        <Breadcrums parentLink="Cartons" isBack={true} />
                    </Grid>
                </Grid>
            </div>

            <Grid row className={classes.gridHeader}>
                <div className={classes.itemTypeFilter}>
                    <Autocomplete
                        options={itemTypeOptions}
                        getOptionLabel={option => option.label || ''}
                        getOptionSelected={(option, value) => option.value === value.value}
                        value={selectedItemType}
                        onChange={handleItemTypeChange}
                        renderInput={params => (
                            <TextField {...params} placeholder="Select Item Type" variant="outlined" size="small" />
                        )}
                    />
                </div>
                <div className={classes.gridActions}>
                    <Button className={classes.changeBtn} onClick={() => setCartonDialog(true)}>
                        <AddCircleOutlineIcon className={classes.addIcon} /> Add New
                    </Button>
                </div>
                <div className={classes.gridActions}>
                    <InputBase
                        value={searchFilter}
                        placeholder="Search"
                        className="grid-search-input"
                        startAdornment={<SearchIcon />}
                        endAdornment={searchFilter ? <ClearIcon className={classes.clearIcon} onClick={() => updateSearch('')} /> : ''}
                        onChange={event => updateSearch(event.target.value)}
                        autoComplete="off"
                    />
                </div>
            </Grid>

            <Grid row className={classes.container}>
                <SearchGrid
                    key={selectedItemType ? selectedItemType.value : 'all'}
                    columns="cartons"
                    list={cartons}
                    noRecordMsg="No record exists"
                    Icon={true}
                    filter={searchFilter}
                    isUpdate={isDataGridUpdate}
                    onEditClick={editCarton}
                    isTopPagination={true}
                />
            </Grid>

            {cartonDialog ? (
                <AddCarton
                    dialogOpenClose={cartonDialog}
                    handleClose={closeCartonDialog}
                    handleSuccessClose={handleSuccessClose}
                    data={editItem}
                    itemTypeOptions={itemTypeOptions}
                />
            ) : ''}
        </>
    );
}

export default withSnackbar(Cartons);
